import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/auth-hook';

import { AuthContext } from "../../context/auth-context";
import './NavLinks.css';

const NavLinks = props => {
  const auth = useContext(AuthContext);

  const { type } = useAuth();


  const openModalHandler = () => {
    auth.toggleModal();
  }

  return <ul className="nav-links">
    {!auth.isLoggedIn && <li>
      <NavLink to="/company">Empresas</NavLink>
    </li>}
    {!auth.isLoggedIn && <li>
      <NavLink to="/" onClick={openModalHandler}>Login</NavLink>
    </li>}
    {auth.isLoggedIn && auth.type == "user" && <li>
      <NavLink to="/users/dashboard">Perfil</NavLink>
    </li>}
    {auth.isLoggedIn && auth.type == "company" && <li>
      <NavLink to="/company/dashboard">Perfil</NavLink>
    </li>}
    {auth.isLoggedIn && <li>
      <NavLink to="/" onClick={auth.logout}>Logout</NavLink>
    </li>}
  </ul>
};

export default NavLinks;